import { OccType, PriceChannel } from '@/config/constant';
import { TodoTaskAction } from '@/redux/actions/todoTask/constant';

// 任务优先级
export enum TaskPriority {
  Urgent = 3, // 严重
  Important = 2, // 重要
  Generally = 0, // 一般
  Minor = 1, // 次要
}

// 排序方式
export enum TaskListOrder {
  CreateTime = '1', // 发起时间
  Priority = '2', // 重要程度
}

// 待办任务类型
export enum TodoTaskCategory {
  ALL = 'TASK_CATEGORY_ALL', // 全部
  RESERVATION = 0, // 订单通知
  CHANNEL = 1, // 渠道通知
  BILL = 3, // 账务通知
  GUEST = 4, // 宾客通知
  DEVICE = 5, // 电脑设备
  MANAGEMENT = 6, // 工作通知
  CUSTOM = 8, // 门店待办
}

// 任务类型
export enum TaskType {
  // 订单通知-预订相关
  RES_PRE_ASSIGN = 0, // 预订待排房
  RES_TEMP_STORAGE = 1, // 预订暂存
  RES_OVERTIME = 2, // 预订超时未入住
  RES_PRE_ASSIGN_FULL = 3, // 待排房已满
  RES_AUTO_CANCELED = 4, // 预订自动取消
  RES_OVERBOOKING = 5, // 超预订提醒
  OTA_BOOK_FEATURE_ROOM_NO_ARRANGE = 6, // 直连预订远期房态未排房

  // 自助点餐
  GOODS_SELF_WAIT_PAY = 120, // 自助点餐待付款
  GOODS_SELF_WAIT_PREPARE = 121, // 自助点餐待备餐
  GOODS_SELF_WAIT_SEND = 122, // 自助点餐待送出
  GOODS_SELF_WAIT_ARRIVAL = 123, // 自助点餐待送达

  // 订单通知-入住相关
  OCC_OVERTIME = 20, // 超时未退房
  OCC_SUGGEST_EXTENSION = 21, // 建议办理续住
  OCC_AUTO_EXTENSION = 22, // 自动续住提醒
  OCC_CONFLICT = 23, // 入住与后续订单冲突

  POLICE_SAFE_CHANGE_ROOM_REMINDER = 24, // 公安系统换房提醒

  // 渠道通知-渠道相关
  CHA_CENTRAL_NEW = 10, // 中央预订申请接单
  CHA_CENTRAL_NEW_AUTO = 15, // 中央预订自动接单
  CHA_CENTRAL_WAIT_PAY = 16, // 中央预订待付款
  CHA_CENTRAL_CANCEL = 11, // 中央预订申请取消
  CHA_AUTO_CANCEL = 12, // 中央预订自动取消
  MT_ZL_NEW_AUTO = 17, // 美团直连自动接单
  MT_ZL_CANCEL = 18, // 美团直连订单取消
  XC_ZL_NEW_AUTO = 19, // 携程直连自动接单
  XC_ZL_CANCEL = 110, // 携程直连订单取消
  PRICE_AUDIT = 13, // 改价审批通过
  PRICE_AUDIT_FAIL = 14, // 改价审批不通过
  DY_ZL_WAIT_PAY = 111, // 抖音直连待付款
  DY_ZL_NEW_AUTO = 112, // 抖音直连自动接单
  DY_ZL_CANCEL = 113, // 抖音直连订单取消
  CHA_CANCEL_FAIL = 114, //  直连订单取消失败
  FEATURE_ROOM_NUM_ALERT = 115, // 远期房量异常提醒

  // 账务通知-财务相关
  ACC_ARREARS = 30, // 订单已欠费
  ACC_UNSETTLED_CANCEL = 31, // 预订取消未结账
  ACC_UNSETTLED_CHECKOUT = 32, // 已退房未结账
  ACC_ROOM_CHECKED = 33, // 查房已完成
  ACC_REFUND_FAILED = 34, // 退款失败
  PAYMENT_ORDER_WAIT_PAY = 35, // 付款单支付中
  PAYMENT_ORDER_PAY_SUCCESS = 36, // 付款单已支付
  MONTHLY_SETTLEMENT = 37, // 月度结账提醒

  // 宾客通知-宾客相关
  CUS_BIRTHDAY = 40, // 宾客生日提醒
  CUS_YOOPLAY_MSG = 41, // 宾客赛事提醒
  CUS_CALL_SERV = 70, // 宾客呼叫服务

  // 电脑设备-设备相关
  FAC_ABNORMAL_SELF_CHECK = 50, // 电脑自动检测异常
  FAC_ABNORMAL_ROOM_CHECK = 51, // 电脑查房检查异常
  FAC_ADMIN_LOGIN_REMIND = 52, // 管理员登录提醒
  FAC_SYS_STATUS_ABNORMAL = 53, // 系统运行异常

  // 工作通知-管理相关
  MAN_TRANSITION = 60, // 交班提醒
  MAN_ROOM_PRICE_AUDIT = 61, // 核查房价提醒
  MAN_NIGHT_AUDIT_FINISHED = 62, // 夜审已完成
  MAN_ENABLE_EMPLOYEE = 63, // 系统账号自动失效

  // 呼叫服务
  CALL_SERVICE_ORDER = 71, // 呼叫服务单

  // 门店待办
  SHOP_CUSTOM = 80, // 门店自定义待办
}

// 待办任务详情
export interface TaskDetail {
  /** 设备相关-异常 */
  changeFields: string; // 电脑异常项
  ip: string; // 电脑ip
  no: number; // 电脑编号
  roomCheckApplyId: number; // 查房异常 id

  /** 账务相关-欠费 */
  // detail: string; // 账务详情
  booker: string; // 预订人

  /** 账务相关-查房 */
  totalPrice: number; // 消费金额(元)
  detail: string; // 查房结果 和 账务详情 都是这个字段
  masterName: string; // 房主名称

  /** 账务相关-欠费 */
  book: boolean; // 是否是预订单
  name: string; // 房主 or 预订人姓名

  /** 宾客相关-生日 */
  customer: string; // 宾客姓名
  expectedArrivalTime: string; // 预抵时间
  expectedDepartureTime: string; // 预离时间
  master: string; // 房主姓名
  occDuration: number; // 入住时长
  occType: OccType; // 入住类型
  payer: string; // 付款人
  paymentType: string; // 支付渠道
  recNo: string; // 子单号
  refundAmount: number; // 退款金额
  resvNo: string; // 主单号
  roomId: number; // 房间id
  srcRoomNo: string; // 原房号
  roomNo: string; // 房号
  roomNum: number; // 房间数量
  roomTypeId: number; // 房型id
  roomTypeName: string; // 房型名称
  newExpectedDepartureTime: string; // 新预离时间
  oldExpectedDepartureTime: string; // 原预离时间

  /** 服务相关-宾客呼叫服务 */
  remark: string; // 呼叫文案
  clientId: string; // 机器编号
  custName: string; // 宾客名称
  callServiceName: string; // 呼叫文案

  // CRS
  expectedArrivalDate: string; // 预抵时间
  expectedDepartureDate: string; // 预离时间
  orderNo: string; // 订单号
  stayLength: string; // 入住天数

  channelName: string; // 渠道名称
  channel: string; // 客源渠道
  channelCode: PriceChannel; // 渠道编码
  channelNo: string; // 渠道单号

  // 渠道同步
  type: number | string; // 同步类型
  syncType: number; // 同步内容

  // 付款单
  subjectName: string; // 账目
  amount: number; // 金额
  countdownSeconds: number; // 剩余支付时间
  paymentTime: string; // 付款时间
  transactionNo: string; // 前台订单号

  // 管理员登录提醒
  computerNo: string; // 机器编号
  computerName: string; // 机器名
  overTimeHours: number; // 超过小时

  // ygp赛事
  yooPlayName: string; // 赛事名称
  startTime: string; // 开始时间

  // 改价审批
  status: number; // 状态
  createTime: string; // 创建时间
  updateTime: string; // 审批时间
  finishRemark: string; // 审批意见
  realApproveName: string; // 审批人
  realApproveUser: string; // 审批人工号
  jobNoName: string; // 提交人
  jobNo: string; // 提交人工号

  reason: string; // 抖音取消原因

  // 自助点餐
  username: string; // 宾客
  saleChannel: string; // 销售渠道
  userRemark: string; // 买家留意
  takeCode: string; // 取餐码
  goodsVOList: {
    linkName: string; // spu
    goodsName: string; // sku
    goodsNum: number; // 数量
  }[];
  businessDate: string; // 排房营业日

  billRoomNo: string; // 入账房号
  roomCheckType: number; // 查房类型
  content: string; // 订单取消失败

  // 呼叫服务
  belongPlaceName: string; // 所属区域名称（电酒为房号）
  machineNumber: string; // 机器编号
  callType: 1 | 2; // 呼叫方式（1-呼叫铃、2-聚玩）
  serviceContentType: string; // 诉求类别
  serviceContentRemark: string; // 备注
  callTimes: number; // 呼叫次数
}

// 处理状态
export enum TaskHandleStatus {
  Todo = 0,
  Done = 1,
  Close = 2,
}

// 处理方式
export enum TaskHandleWay {
  Know = 1, // 已知晓
  Done = 2, // 已处理
  Close = 3, // 强制关闭
}

// 待办任务基础信息
export interface TodoTaskInfo {
  id: number; // 任务id
  type: TaskType; // 任务类型
  handleFlag: boolean; // 0未处理 1 已处理
  level: TaskPriority; // 0普通 1重要
  content: string; // 提醒内容
  createBy: string; // 创建人
  createTime: number; // 创建时间
  commonCode: string; // 门店码
  updateBy: string; // 修改人
  updateTime: string; // 修改时间
  data: TaskDetail;
  typeGroup: TodoTaskCategory; // 任务分类
  typeName: string; // 分类名称
  handleStatus: TaskHandleStatus;
  cancelable: boolean; // 是否允许关闭(true允许关闭，false不允许)
}

export interface FilterParam {
  categoryType: TodoTaskCategory; // 分组
  listOrderType: TaskListOrder; // 排序方式
}

export interface ReducerState {
  filterParam: FilterParam; // 筛选
  todoListData: TodoTaskInfo[]; // 待办任务
}

const initState: ReducerState = {
  filterParam: {
    categoryType: TodoTaskCategory.ALL,
    listOrderType: TaskListOrder.CreateTime,
  },
  todoListData: [],
};

// action handler
type ActionHandler<T> = (state: ReducerState, action: { payload: T }) => ReducerState;
const reducerMap = {
  [TodoTaskAction.setTodoList]: <ActionHandler<TodoTaskInfo[]>>((state, { payload }) => {
    return {
      ...state,
      todoListData: payload,
    };
  }),
  [TodoTaskAction.setFilterParam]: <ActionHandler<FilterParam>>((state, { payload }) => {
    return {
      ...state,
      filterParam: payload,
    };
  }),
};

export const reducerMapper = (state = initState, action) => {
  const actionType = action.type;
  const reducer = reducerMap[actionType];
  if (typeof reducer === 'function') {
    return reducer(state, action);
  }
  return state;
};

export const storeName = 'todoTask';
